import type { ReactNode } from 'react';
import { Svg } from '../../primitives/Svg.js';
import { useDecorativeIconMotion } from '../../primitives/useIconMotion.js';
import type { IconProps } from '../../primitives/types.js';

/** Flame — flickers with a non-uniform vertical scale anchored at its
 *  base (8,12) so the tip dances while the foot stays planted; a small
 *  ember embers inside on a slower loop. */
export function IcnFlame(props: IconProps): ReactNode {
  const animate = useDecorativeIconMotion();
  return (
    <Svg {...props} iconName="flame">
      <g style={{ transformOrigin: '8px 12px' }}>
        {animate && (
          <animateTransform
            attributeName="transform"
            type="scale"
            values="1 1;1.01 1.1;0.99 0.94;1.02 1.08;1 1"
            keyTimes="0;0.25;0.5;0.75;1"
            dur="1.1s"
            repeatCount="indefinite"
            additive="sum"
          />
        )}
        <path d="M8 2C7 5 4 6 4 9.5A4 4 0 0 0 12 9.5c0-2-1.5-3-2-5-1 1-1.5 2-2 1.5C7.5 5 8 3 8 2z" />
        <path
          d="M8 7.5C7.5 9 6.5 9.5 6.5 10.5A1.5 1.5 0 0 0 9.5 10.5C9.5 9.5 8.5 9 8 7.5z"
          fill="currentColor"
          stroke="none"
          opacity="0.6"
        >
          {animate && (
            <animate
              attributeName="opacity"
              values="0.35;0.85;0.35"
              dur="0.9s"
              repeatCount="indefinite"
            />
          )}
        </path>
      </g>
    </Svg>
  );
}
